'use client'
import React, { useMemo } from 'react'
import styles from './styles.module.scss'
import { SearchInput } from '../SearchInput'

interface SearchProps {
  onSearchChange: (event: React.FormEvent<HTMLInputElement>) => void
  value: string
  searchClear: () => void
  title?: string
  titleSize?: 'h1' | 'h2'
}
const SearchWithTitle: React.FC<SearchProps> = ({
  onSearchChange,
  value,
  searchClear,
  title,
  titleSize = 'h2',
}) => {
  const searchTitle = useMemo(() => {
    switch (titleSize) {
      case 'h1':
        return <h1 className={styles.h1Title}>{title}</h1>
      default:
        return <h2 className={styles.h2Title}>{title}</h2>
    }
  }, [title, titleSize])

  return (
    <div className={styles.container}>
      <div className={styles.panel}>
        {title && searchTitle}
        <SearchInput
          value={value}
          onClear={searchClear}
          onChange={onSearchChange}
        />
      </div>
    </div>
  )
}

export default SearchWithTitle
